import React, { Component } from 'react';
import './NotificationPopoverCell.css';

class NotificationPopoverCell extends Component {
  acceptNotification = () => {
    const { notification } = this.props;
    this.props.onAccept(notification);
  }

  declineNotification = () => {
    const { notification } = this.props;
    this.props.onDecline(notification);
  }

  renderRoomNotification = (notification) => {
    const { room, sender } = notification;
    return (<li className="NotificationPopoverCell">
      <div className="NotificationPopoverCell__avatar-wrap">
        <img className="NotificationPopoverCell__avatar" src={sender.avatar} alt="" />
      </div>
      <div className="NotificationPopoverCell__content">
        <strong>{sender.displayName}</strong> invited you to join <strong>{room.name}</strong>.
      </div>

      <div className="NotificationPopoverCell__actions">
        <a href="#" onClick={this.acceptNotification}>Accept</a>
        <a href="#" onClick={this.declineNotification}>Decline</a>
      </div>
    </li>);
  }

  renderFriendNotification = (notification) => {
    const { sender } = notification;
    return (<li className="NotificationPopoverCell">
      <div className="NotificationPopoverCell__avatar-wrap">
        <img className="NotificationPopoverCell__avatar" src={sender.avatar} alt="" />
      </div>
      <div className="NotificationPopoverCell__content">
        <strong>{sender.displayName}</strong> invited you to become friends.
      </div>

      <div className="NotificationPopoverCell__actions">
        <a href="#" onClick={this.acceptNotification}>Accept</a>
        <a href="#" onClick={this.declineNotification}>Decline</a>
      </div>
    </li>);
  }

  render() {
    const { notification } = this.props;

    switch(notification.type) {
      case 'RoomNotification':
        return this.renderRoomNotification(notification);
      case 'FriendNotification':
        return this.renderFriendNotification(notification);
      default:
        return null;
    };
  }
}

export default NotificationPopoverCell;



// WEBPACK FOOTER //
// ./src/components/NotificationPopoverCell.js